import { render, staticRenderFns } from "./MexicoCity.vue?vue&type=template&id=941f13ba&"
import script from "./MexicoCity.vue?vue&type=script&lang=js&"
export * from "./MexicoCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports